import { render, staticRenderFns } from "./PaxelLoader.vue?vue&type=template&id=16a30c08&scoped=true&"
import script from "./PaxelLoader.vue?vue&type=script&lang=js&"
export * from "./PaxelLoader.vue?vue&type=script&lang=js&"
import style0 from "./PaxelLoader.vue?vue&type=style&index=0&id=16a30c08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a30c08",
  null
  
)

export default component.exports